<template>
  <div
    class="preview"
    :class="[computedCharacterColorClass]"
  >
    <!-- character-code for mixin.character -->
    <component
      v-if="true"
      :is="computedComponentName"
      :class="[computedCharacterColorClass]"
      :character-code="characterColor"
      :columns="detail.columns"
      :typography="detail.typography"
      :sanskrit-character-or-family-emblem="detail.sanskritCharacterOrFamilyEmblem"
      :sanskrit-character="detail.sanskritCharacter"
      :custom-sanskrit-character-url="detail.customSanskritCharacterUrl"
      :family-emblem="detail.familyEmblem"
      :custom-family-emblem-url="detail.customFamilyEmblemUrl"
      :secular-name-prefix="detail.secularNamePrefix"
      :under-characters="detail.underCharacters"
      :under-characters-placement="detail.underCharactersPlacement"
      :age-unit-character="detail.ageUnitCharacter"
      :age-at-death-prefix="detail.ageAtDeathPrefix"
      :age-at-death-prefix-placement="detail.ageAtDeathPrefixPlacement"
      :died-character="detail.diedCharacter"
      :host-name="detail.hostName"
      @onClickCharacter="$listeners['onClickCharacter']"
    />
  </div>
</template>

<script>
// 通常位牌 1霊
import N1East from "@/components/Common/TabletPreview/Items/Layouts/N1East/Front.vue";
import N1West from "@/components/Common/TabletPreview/Items/Layouts/N1West/Front.vue";
// 通常位牌 2霊
import N2East from "@/components/Common/TabletPreview/Items/Layouts/N2East/Front.vue";
import N2East2 from "@/components/Common/TabletPreview/Items/Layouts/N2East2/Front.vue";
import N2East3 from "@/components/Common/TabletPreview/Items/Layouts/N2East3/Front.vue";
import N2West from "@/components/Common/TabletPreview/Items/Layouts/N2West/Front.vue";
import N2West2 from "@/components/Common/TabletPreview/Items/Layouts/N2West2/Front.vue";
import N2West3 from "@/components/Common/TabletPreview/Items/Layouts/N2West3/Front.vue";
// 俗名位牌 1霊
import S1East from "@/components/Common/TabletPreview/Items/Layouts/S1East/Front.vue";
import S1West from "@/components/Common/TabletPreview/Items/Layouts/S1West/Front.vue";
// マインドアルテ 1霊
import M1A from "@/components/Common/TabletPreview/Items/Layouts/M1A/Front.vue";
import M1B from "@/components/Common/TabletPreview/Items/Layouts/M1B/Front.vue";
// マインドアルテ 2霊
import M2 from "@/components/Common/TabletPreview/Items/Layouts/M2/Front.vue";

// Mixins
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.component,
    TabletPreviewMixin.character,
  ],
  components: {
    N1East,
    N1West,
    N2East,
    N2East2,
    N2East3,
    N2West,
    N2West2,
    N2West3,
    S1East,
    S1West,
    M1A,
    M1B,
    M2,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-common.scss";
</style>
